import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import FieldLabelWrapper from '../../../../../../features/components/Form/FieldLabelWrapper'
import Field from '../../../../../../components/Form/Field'

import { formatNumber } from '../../../../../../helpers/numbers'

import FrequencyCapFields from '../../formFields/FrequencyCapFields'
import CampaignObjectiveFields from '../formFields/CampaignObjectiveFields'
import ErrorMessage from '../../../../../../components/Form/ErrorMessage'

import { selectedDV360AdAccountSelector } from '../../../../../../modules/selectors/adAccounts'

import { PLANNED_SPEND_AMOUNT } from '../../../../CampaignForms/CampaignDv360Create/CampaignDv360CreateForm/fields'
import { PACING_TYPE, pacingTypeOptions } from '../fields'

import useDrawerFormStyles from '../../../../../../styles/common/drawerForms'

const NewCampaignBudgetFields = ({ formik, remainingBudget }) => {
  const { t } = useTranslation()
  const drawerFormClasses = useDrawerFormStyles()

  const { currency_symbol: currencySymbol } = useSelector(selectedDV360AdAccountSelector)

  if (remainingBudget < 1) {
    return <ErrorMessage fontSize={14} error="Your total remaining budget is too low to create a campaign." />
  }

  return (
    <div className={drawerFormClasses.subSection}>
      <CampaignObjectiveFields formik={formik} />
      <div className={drawerFormClasses.subSection}>
        <FieldLabelWrapper label={t('Budget')} labelFor={PLANNED_SPEND_AMOUNT}>
          <p>
            {t(
              'Please set a budget for this campaign. The budget will be shared across ad sets according to performance.'
            )}
          </p>
          <p>{t(`Your remaining budget is ${currencySymbol}` + formatNumber(remainingBudget, { max: 2 }))}</p>
          <Field
            placeholder="Lifetime budget"
            formik={formik}
            name={PLANNED_SPEND_AMOUNT}
            enableReinitialize
            autoComplete="off"
            inputMode="numeric"
            type="number"
            symbol={currencySymbol}
          />
        </FieldLabelWrapper>
        <FieldLabelWrapper label={t('Pacing')} labelFor={PACING_TYPE}>
          <Field placeholder="Pacing" formik={formik} name={PACING_TYPE} options={pacingTypeOptions} />
        </FieldLabelWrapper>
      </div>

      <div className={drawerFormClasses.subSection}>
        <FrequencyCapFields formik={formik} />
      </div>
    </div>
  )
}

export default NewCampaignBudgetFields
